import { Reveal, ChapterTag } from "@/components/Reveal";

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="grain relative overflow-hidden bg-obsidian px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal className="text-center">
        <ChapterTag index="02" label="The Difference" />
      </Reveal>
      <div className="mt-10">
        <Reveal delay={0.15} className="mx-auto max-w-3xl text-center">
          <h2 className="font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl lg:text-6xl">
            Not a Fixed Package. <span className="italic text-gold-gradient">Your Journey.</span>
          </h2>
          <div className="mt-8 space-y-4 text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
            <p>We don't believe every traveler should fit into the same itinerary.</p>
            <p>
              Your destination, accommodation, transportation, sightseeing, activities and other
              arrangements are planned around what matters to you.
            </p>
            <p>
              Whether you're looking for a simple getaway or a more indulgent escape, we'll recommend
              the best experience possible within your requirements and budget.
            </p>
          </div>
          <p
            data-testid="manifesto-line"
            className="mx-auto mt-12 inline-block border-t border-gold/50 pt-6 font-serif text-xl font-light italic leading-snug text-gold sm:text-2xl"
          >
            Not a one-size-fits-all itinerary. A journey built around you.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
